
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1729477827862",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "1968",
    "width": "16",
    "height": "16"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M608 960H512V128h256v128a64 64 0 0 0 128 0V64a64 64 0 0 0-64-64H64a64 64 0 0 0-64 64v192a64 64 0 0 0 128 0V128h256v832H288a32 32 0 0 0 0 64h320a32 32 0 0 0 0-64z",
        "p-id": "1969"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M992 832a32 32 0 0 0 32-32v-192a32 32 0 0 0-32-32h-256a32 32 0 0 0 0 64H960v128h-224a32 32 0 0 0-32 32v192a32 32 0 0 0 32 32h256a32 32 0 0 0 0-64H768v-128z",
        "p-id": "1970"
      }
    }
  ]
})
    }
  